import { EdProgramDto, EdProgramPurpose } from 'src/types/EdProgram';
import { AreaId } from 'src/types/area';
import { CalculatorSkillsGroup } from 'src/types/calculator';
import { Currency } from 'src/types/common';
import { ProfessionDescriptionDto, ProfessionDescriptionGrade, ProfessionId } from 'src/types/profession';

export enum ProfessionAreaChartDirection {
    EQUAL = 'EQUAL',
    LESS = 'LESS',
    MORE = 'MORE',
}

export enum CurrentSectionState {
    STATISTIC = 'statistic',
    CALCULATOR = 'calculator',
    COURSES = 'courses',
    CAREERTRACK = 'career_track',
}

export enum ProfessionScrollAnchors {
    Calculator = 'anchor-calculator',
    Professions = 'anchor-professions',
    Skills = 'anchor-skills',
    HigherEducation = 'anchor-higherEducation',
}

export interface StatisticDetailItem {
    id: number;
    count: number;
    percent: number;
    salary: {
        from: number;
        to: number;
    };
    salaryStr: string;
    redirect: {
        link: string;
        placeholder: null | string;
    };
}

export interface ProfessionAreaChartItem {
    year: number;
    value: number;
    diff: {
        value: number;
        direction: ProfessionAreaChartDirection;
    };
    isCurrency: boolean;
}

interface ProfessionStatisticDetail {
    values: StatisticDetailItem[];
    initValue: StatisticDetailItem;
}

interface ProfessionStatisticSalary {
    values: ProfessionAreaChartItem[];
    initValue: ProfessionAreaChartItem | null;
}

interface ProfessionStatisticVacancies {
    values: ProfessionAreaChartItem[];
    initValue: ProfessionAreaChartItem | null;
}

export interface ProfessionTopVacancy {
    name: string;
    region: string;
    salaryFrom: string;
    currency: Currency;
    employerName: string;
    redirect: {
        placeholder: string;
        link: string;
    };
}

interface ProfessionStatisticTopVacancies {
    vacancies: ProfessionTopVacancy[];
    redirect: {
        placeholder: string;
        link: string;
    };
}

export interface IndicationResponse {
    matchPercent: number;
    userCountSkill: number;
    professionCountSkill: number;
}

export interface ProfessionInitialState {
    professionId: ProfessionId;
    profession: ProfessionDescriptionDto;
    currentSection: CurrentSectionState;
    currentRegion: AreaId;
    currentGrade: ProfessionDescriptionGrade | null;
    statistic: {
        blurred: boolean;
        salary: ProfessionStatisticSalary;
        vacancies: ProfessionStatisticVacancies;
        detail: ProfessionStatisticDetail;
        topVacancies: ProfessionStatisticTopVacancies;
    };
    calculator: {
        skillsGroup: CalculatorSkillsGroup[];
    };
    courses: Record<EdProgramPurpose, EdProgramDto[]>;
    matchIndicator: IndicationResponse | null;
}
